export default __webpack_public_path__ + "static/media/indoor_poster_blue_reduced.38c600d6.jpg";